var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3125 13.3125C26.3125 20.4808 20.4809 26.3125 13.3125 26.3125C6.14416 26.3125 0.3125 20.4808 0.3125 13.3125C0.3125 6.14416 6.14415 0.3125 13.3125 0.3125C20.4809 0.3125 26.3125 6.14416 26.3125 13.3125ZM23.7964 13.3125C23.7964 7.53163 19.0934 2.82863 13.3125 2.82863C7.53163 2.82863 2.82863 7.53163 2.82863 13.3125C2.82863 19.0934 7.53163 23.7964 13.3125 23.7964C19.0934 23.7964 23.7964 19.0934 23.7964 13.3125ZM17.5061 14.5693H13.3125C12.6176 14.5693 12.0545 14.0062 12.0545 13.3112V6.33943C12.0545 5.64447 12.6176 5.08137 13.3125 5.08137C14.0075 5.08137 14.5706 5.64447 14.5706 6.33943V12.0531H17.5061C18.201 12.0531 18.7641 12.6162 18.7641 13.3112C18.7641 14.0062 18.201 14.5693 17.5061 14.5693Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.1651f79e.svg";
export { ForwardRef as ReactComponent };